export const iconFontAwesomeArrowsTurnUp = (
	<i className="fa-solid fa-turn-up"></i>
);
